// extracted by mini-css-extract-plugin
export default {"tabGroup":"_2C1oB7AGsM9rI2df0lbG7z"};